import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { getPartners } from "../../apis/partner/partner";
import { setTrialRequestPartners } from "../../utils/trial";
import Modal, { ModalHeader } from "../Modal";
import { TrialRequestPartnerList } from "../Partner/TrialRequestPartnerList";

export const TrialRequestPartners = () => {
  const [partners, setPartners] = useState([]);
  const {
    isTrialRequestPartners,
    // employee
  } = useSelector(
    (store) => ({
      // employee: store.Profile.employee,
      isTrialRequestPartners: store.Data.isTrialRequestPartners,
    }),
    shallowEqual
  );

  const close = () => {
    setTrialRequestPartners(null);
  };

  useEffect(() => {
    getPartners().then((data) => {
      setPartners(data.partners);
    });
  }, []);

  return (
    <Modal
      className="trial-request-partner-modal"
      isOpen={!!isTrialRequestPartners}
      close={close}
    >
      {isTrialRequestPartners && (
        <>
          <ModalHeader>
            위케이크 파트너 세무사 <small>(위치권한을 승인하면 가까운 순서로 보실 수 있습니다.)</small>
          </ModalHeader>
          <div className="trial-container">
            <TrialRequestPartnerList partners={partners} close={close} />
          </div>
        </>
      )}
    </Modal>
  );
};
